import type { ComponentProps, ReactElement, ReactNode } from 'react';
import { Check } from 'lucide-react';

import { Button } from '@/components/ui/button';

import usePlusUpgradeRequested from './usePlusUpgradeRequested';

interface RequestPlusButtonProps extends Pick<ComponentProps<typeof Button>, 'size' | 'className'> {
  onClick: () => void;
  organisationId?: string;
  children: ReactNode;
}

// The "Request Upgrade" button of every Plus upsell. Once the organisation has asked for Plus it stays
// disabled as "Upgrade requested" until account management switch the plan, and it waits until that
// is known so a second request can't slip through.
export default function RequestPlusButton({
  onClick,
  organisationId,
  children,
  size,
  className,
}: RequestPlusButtonProps): ReactElement {
  const { requested, isLoading } = usePlusUpgradeRequested(organisationId);

  if (requested) {
    return (
      <Button size={size} className={className} disabled>
        <Check aria-hidden="true" />
        Upgrade requested
      </Button>
    );
  }

  return (
    <Button size={size} className={className} disabled={isLoading} onClick={onClick}>
      {children}
    </Button>
  );
}
